import Instance from "../../../../Axios";

// New Actions for the app

const GetAllPropostasEstados = () => async (dispatch) => {
  await Instance()
    .get(`/energias/dashboard/allPropostasEstados`)
    .then(({ data }) => {
      dispatch({
        type: "GET_ALL_PROPOSTAS_ESTADOS",
        payload: data.yData,
      });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetAllPropostasEstados;